module.exports = require('./dist/ReactCrop');



//////////////////
// WEBPACK FOOTER
// ./~/react-image-crop/index.js
// module id = 715
// module chunks = 0